export enum EThreeStateCheckbox {
  UNCHECK = 0,
  CHECK = 1,
  INDETERMINATE = 2
}
